export { default } from './LlistatResultats';
